import React from "react";
import { Avatar, Typography } from "@mui/material";

const AvatarComponent = ({ user, size }) => {
  if (user) {
    return (
      <Avatar
        style={{
          width: size ? size : 50,
          height: size ? size : 50,
          fontSize: size ? size * 0.7 : 50 * 0.7,
          background: "#2a364a",
          color: "#fff"
        }}
        src={user.profile ? user.profile?.avatar : ""}
      >
        <Typography fontWeight={800}>{user.username?.charAt(0).toUpperCase()}</Typography>
      </Avatar>
    );
  }
  return null;
};

export default AvatarComponent;
